export default "__VITE_ASSET__738aecd9__"